import React, { memo } from "react";
import useStyles from "./styles";

import { Grid, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Images } from "config/images";

const NotFoundPage = () => {
	const classes = useStyles();
	const history = useHistory();

	const handleGoBack = () => {
		history.goBack();
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.bodyPage }}>
				<Grid style={{ textAlign: "center" }}>
					<img src={Images.ic404} alt="ic404" />
					<Grid classes={{ root: classes.text }}>
						Xin lỗi, trang bạn đã truy cập không tồn tại
					</Grid>
					<Button
						variant="outlined"
						color="primary"
						onClick={() => handleGoBack()}
						classes={{ root: classes.rootBtn }}
					>
						Quay lại
					</Button>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(NotFoundPage);
